export const DocumentUploadConstants = {
  BROWSE_FILES: "Upload Documents",
  DRAG_DROP: "Maximum Limit of 5MB",
  FILES_HERE: "your files here",
  OR: "or",
  TAKE_PICTURE: "Take a picture",
  CAPTURE: "Capture",
  CANCEL: "Cancel",
  SAVE: "Save",
  PLEASE_WAIT: "Please wait!"
} as const;
